module.exports = __webpack_public_path__ + "static/pdf-playbook-f2018a2ac7fba521e37f87a5021332d1.png";